import React, { useEffect, useRef, useState } from "react";
import apiClient from '../../../../services/apiClient';
const SendToCustomerFormModal = ({ fun, eventid }) => {
  const [contracts, setContracts] = useState([]);
  const [Invoices, setInvoices] = useState([]);
  const [proposals, setProposals] = useState([]);
  const [Questionnaires, setQuestionnaires] = useState([]);

  useEffect(() => {
    // Fetch the contracts data from the API
    const fetchContracts = async () => {
      try {
        const response = await apiClient.post(
          `/contracts_list`,
          { user_id: JSON.parse(localStorage.getItem("user")).user.id }
        );
        setContracts(response.data);
      } catch (error) {
        console.error("Error fetching contracts:", error);
      }
    };
    const fetchInvoices = async () => {
      try {
        const response = await apiClient.post(
          `/invoices_list`,
          { user_id: JSON.parse(localStorage.getItem("user")).user.id }
        );
        setInvoices(response.data);
      } catch (error) {
        console.error("Error fetching contracts:", error);
      }
    };
    const fetchProposals = async () => {
      try {
        const response = await apiClient.post(
          `/proposal_list`,
          { user_id: JSON.parse(localStorage.getItem("user")).user.id }
        );
        setProposals(response.data);
      } catch (error) {
        console.error("Error fetching contracts:", error);
      }
    };

    const fetchQuestionnaires = async () => {
      try {
        const response = await apiClient.post(
          `/questionnaires_list`,
          { user_id: JSON.parse(localStorage.getItem("user")).user.id }
        );

        setQuestionnaires(response.data);
      } catch (error) {
        console.error("Error fetching contracts:", error);
      }
    };

    fetchProposals();
    fetchContracts();
    fetchInvoices();
    fetchQuestionnaires();
  }, []);

  return (
    <div
      className="modal fade"
      id="exampleModal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
        style={{ minHeight: "700px" }}
      >
        <div className="modal-content">
          {/* Modal header */}
          <div className="modal-header bg-primary">
            <h5 className="modal-title text-white w-100 text-center">
              Send To Customer
            </h5>
            <button
              type="button"
              className="close"
              data-bs-dismiss="modal"
              id="clobtn1"
            >
              <span aria-hidden="true" className="modal_button">
                <i className="fas fa-close"></i>
              </span>
              <span className="sr-only">Close</span>
            </button>
          </div>

          <div
            className="modal-body py-5 px-4"
            style={{ background: "#f1f5f9" }}
          >
            <div className="row d-flex">
              <div
                className="col-lg-2 col-md-1"
                style={{ width: "12%", lineHeight: "40px" }}
              >
                <b className="pt-1 fw-normal"> Filter by : </b>
              </div>
              <div
                className="col-lg-10 col-md-11"
                style={{ marginLeft: "0px", width: "88%" }}
              >
                <div
                  className="filter_bt nav nav-tabs"
                  id="nav-tab"
                  role="tablist"
                  style={{ marginLeft: "0px" }}
                >
                  <a
                    className="nav-link active"
                    id="All-tab"
                    data-bs-toggle="tab"
                    href="#All"
                    role="tab"
                  >
                    All
                  </a>
                  <a
                    className="nav-link"
                    id="proposals-tab"
                    data-bs-toggle="tab"
                    href="#fill-tabpanel-Proposals"
                    role="tab"
                  >
                    Proposals
                  </a>
                  <a
                    className="nav-link"
                    id="contract-tab"
                    data-bs-toggle="tab"
                    href="#fill-tabpanel-Contract"
                    role="tab"
                  >
                    Contract
                  </a>
                  <a
                    className="nav-link"
                    id="invoices-tab"
                    data-bs-toggle="tab"
                    href="#fill-tabpanel-Invoices"
                    role="tab"
                  >
                    Invoices
                  </a>
                  <a
                    className="nav-link"
                    id="questionnaires-tab"
                    data-bs-toggle="tab"
                    href="#fill-tabpanel-Questionnaires"
                    role="tab"
                  >
                    Questionnaires
                  </a>
                  <a
                    className="nav-link"
                    id="tour-tab"
                    data-bs-toggle="tab"
                    href="#fill-tabpanel-Tour"
                    role="tab"
                  >
                    Tour
                  </a>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="tab-content" id="nav-tabContent">
                  {/* Proposals tab pane */}
                  <div
                    className="tab-pane fade show active"
                    id="All"
                    role="tabpanel"
                  >
                    <table className="table table-borderless modal-tb p-4 ">
                      <thead>
                        <tr>
                          <th>NAME</th>
                          <th>CATEGORY</th>
                        </tr>
                      </thead>
                      <tbody>
                        {proposals.map((proposal) => (
                          <tr key={proposal.id}>
                            <td>
                              <a
                                href={
                                  "../Send-Proposal/" +
                                  eventid +
                                  "/" +
                                  proposal.id
                                }
                              >
                                {proposal.title.toUpperCase()}
                              </a>
                            </td>
                            <td>PROPOSAL</td>
                          </tr>
                        ))}

                        {Invoices.map((Invoice) => (
                          <tr key={Invoice.id}>
                            <td>
                              <a
                                href={
                                  "../Send-Invoice/" +
                                  eventid +
                                  "/" +
                                  Invoice.id
                                }
                              >
                                {Invoice.title.toUpperCase()}
                              </a>
                            </td>
                            <td>INVOICES</td>
                          </tr>
                        ))}

                        {contracts.map((contract) => (
                          <tr key={contract.id}>
                            <td>
                              <a
                                href={
                                  "../Send-contract/" +
                                  eventid +
                                  "/" +
                                  contract.id
                                }
                              >
                                {contract.title.toUpperCase()}
                              </a>
                            </td>
                            <td>CONTRACT</td>
                          </tr>
                        ))}

                        {Questionnaires.map((Questionnaire) => (
                          <tr key={Questionnaire.id}>
                            <td>
                              <a
                                href={
                                  "../Send-Questionnaires/" +
                                  eventid +
                                  "/" +
                                  Questionnaire.id
                                }
                              >
                                {Questionnaire.title.toUpperCase()}
                              </a>
                            </td>
                            <td>QUESTIONNAIRES</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Proposals tab pane */}
                  <div
                    className="tab-pane fade"
                    id="fill-tabpanel-Proposals"
                    role="tabpanel"
                  >
                    <table className="table table-borderless modal-tb p-4 fixed_header">
                      <thead>
                        <tr>
                          <th>NAME</th>
                          <th>CATEGORY</th>
                        </tr>
                      </thead>
                      <tbody>
                        {proposals.map((proposal) => (
                          <tr key={proposal.id}>
                            <td>
                              <a
                                href={
                                  "../Send-Proposal/" +
                                  eventid +
                                  "/" +
                                  proposal.id
                                }
                              >
                                {proposal.title.toUpperCase()}
                              </a>
                            </td>
                            <td>PROPOSAL</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Contract tab pane */}
                  <div
                    className="tab-pane fade"
                    id="fill-tabpanel-Contract"
                    role="tabpanel"
                  >
                    <table className="table table-borderless modal-tb p-4 fixed_header">
                      <thead>
                        <tr>
                          <th>NAME</th>
                          <th>CATEGORY</th>
                        </tr>
                      </thead>
                      <tbody>
                        {contracts.map((contract) => (
                          <tr key={contract.id}>
                            <td>
                              <a
                                href={
                                  "../Send-contract/" +
                                  eventid +
                                  "/" +
                                  contract.id
                                }
                              >
                                {contract.title.toUpperCase()}
                              </a>
                            </td>
                            <td>CONTRACT</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Invoices tab pane */}
                  <div
                    className="tab-pane fade"
                    id="fill-tabpanel-Invoices"
                    role="tabpanel"
                  >
                    <table className="table table-borderless modal-tb p-4 fixed_header">
                      <thead>
                        <tr>
                          <th>NAME</th>
                          <th>CATEGORY</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Invoices.map((Invoice) => (
                          <tr key={Invoice.id}>
                            <td>
                              <a
                                href={
                                  "../Send-Invoice/" +
                                  eventid +
                                  "/" +
                                  Invoice.id
                                }
                              >
                                {Invoice.title.toUpperCase()}
                              </a>
                            </td>
                            <td>INVOICES</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Questionnaires tab pane */}
                  <div
                    className="tab-pane fade"
                    id="fill-tabpanel-Questionnaires"
                    role="tabpanel"
                  >
                    <table className="table table-borderless modal-tb p-4 fixed_header">
                      <thead>
                        <tr>
                          <th>NAME</th>
                          <th>CATEGORY</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Questionnaires.map((Questionnaire) => (
                          <tr key={Questionnaire.id}>
                            <td>
                              <a
                                href={
                                  "../Send-Questionnaires/" +
                                  eventid +
                                  "/" +
                                  Questionnaire.id
                                }
                              >
                                {Questionnaire.title.toUpperCase()}
                              </a>
                            </td>
                            <td>QUESTIONNAIRES</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Tour tab pane */}
                  <div
                    className="tab-pane fade"
                    id="fill-tabpanel-Tour"
                    role="tabpanel"
                  >
                    <table className="table table-borderless modal-tb p-4 fixed_header">
                      <thead>
                        <tr>
                          <th>NAME</th>
                          <th>CATEGORY</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>PROPOSAL-2 HOUR EVENT</td>
                          <td>TOUR</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendToCustomerFormModal;
